 <template>
  <div class="content-table" style="position: relative">
    <el-backtop></el-backtop>
    <div class="content-row" style="margin-bottom: 0; margin-top: 1%">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"
          >首页</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 二级分类 -->
    <!-- 分类列表临时注释 -->
    <!-- <div class="list-nav-two">
      <el-tag
        v-for="(item,index) in tag_list"
        :key="item.id"
        type="warning"
        closable
        effect="plain"
        @close="handleClose(item,index)"
      >{{ item.good_cate_name}}</el-tag>
    </div>

    <div class="content-row">
      <ul class="cate-menu f-15">
        <li
          v-for="(item,index) in cate_list"
          :key="index"
          :class="cate_id1 == item.good_cate_itemid ? 'cate-menu-li menu-active' : 'cate-menu-li'"
          @click="showChildMenu(item.good_cate_itemid,item)"
        >
          {{item.good_cate_name}}
        </li>
      </ul>
    </div>
    <div class="content-row"></div>
    <div class="content-row attr-table-less">
      <el-table
        :data="attr_list_less"
        :show-header="false"
        :cell-style="cellStyle"
        border
        class="table-attr f-14"
        id="attr-table"
      >
        <el-table-column prop="good_attr_name" label min-width="100" width="140"></el-table-column>
        <el-table-column label style="display:flex;flex-flow:wrap;">
          <template slot-scope="scope">
            <span
              class="span-attr-value"
              v-for="(item,index) in scope.row.value"
              :key="index"
              v-show="index < scope.row.long"
            >
              <el-checkbox
                v-model="item.rick"
                @change="showDetailList($event,item.good_attr_id)"
              >{{item.good_attr_value}}</el-checkbox>
            </span>
            <span
              class="span-most"
              @click="scope.row.long == 7 ? scope.row.long = 100 : scope.row.long = 7"
            >
              {{scope.row.long != 7 ? '收起' : '更多'}}
              <i
                :class=" scope.row.long == 100 ?'fa fa-angle-double-up':'fa fa-angle-double-right'"
                aria-hidden="true"
              ></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span class="span-table-most">
        <span @click="showMostListData()" class="f-15-gray">
          更多
          <i class="fa fa-angle-double-down" aria-hidden="true"></i>
        </span>
      </span>
    </div>-->
    <!-- 分类列表临时注释end  修改时间2019年12月12日-->
    <div class="content-row attr-table-most hide f-14">
      <el-table
        :data="attr_list_most"
        :show-header="false"
        :cell-style="cellStyle"
        border
        class="table-attr f-14"
      >
        <el-table-column
          prop="good_attr_name"
          label
          min-width="100"
          width="140"
        ></el-table-column>
        <el-table-column label>
          <template slot-scope="scope">
            <span
              class="span-attr-value"
              v-for="(item, index) in scope.row.value"
              :key="index"
              v-show="index < scope.row.long"
            >
              <el-checkbox
                v-model="item.rick"
                @change="showDetailList($event, item.good_attr_id)"
                >{{ item.good_attr_value }}</el-checkbox
              >
              <!-- <input type="checkbox" :value="item.id" @click="showDetailList($event,item.id)" />
              <span>{{item.good_attr_value}}</span>-->
            </span>
            <span
              class="span-most"
              @click="
                scope.row.long != 7
                  ? (scope.row.long = 7)
                  : (scope.row.long = 100)
              "
            >
              {{ scope.row.long == 100 ? "收起" : "更多" }}
              <i
                :class="
                  scope.row.long == 100
                    ? 'fa fa-angle-double-up'
                    : 'fa fa-angle-double-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span class="span-table-most f-15-gray">
        <span @click="showLessListData()">
          收起
          <i class="fa fa-angle-double-up" aria-hidden="true"></i>
        </span>
      </span>
    </div>
    <div class="content-row">
      <ul class="fillter-menu">
        <li>
          <span class="cursor" @click="sortGoodList('all')">综合排序</span>
          <!-- <i class="el-icon-d-caret" @click="sortGoodList('all')"></i> -->
        </li>
        <li>
          <!-- 规格型号 -->
          <!-- <i class="el-icon-d-caret" @click="sortGoodList('name')"></i> -->
        </li>
        <li>
          价格
          <i class="el-icon-d-caret" @click="sortGoodList('price')"></i>
        </li>
        <!-- <li>
          <el-input class="input-price" size="small" v-model="min_price" placeholder="请输入最低价"></el-input>
          <span>~</span>
          <el-input class="input-price" size="small" v-model="max_price" placeholder="请输入最高价"></el-input>
        </li>
        <li>
          <el-button type="warning" @click="getGoodList()" size="small">确定</el-button>
        </li>-->
        <li class="te-li-right">
          <span
            class="te-li-right-span"
            :class="{ active: showlistShop == false }"
            @click="show_listShop(1)"
          >
            <i class="el-icon-menu"></i> 大图
          </span>
          <span
            class="te-li-right-span"
            :class="{ active: showlistShop == true }"
            @click="show_listShop(2)"
          >
            <i class="el-icon-tickets"></i> 列表
          </span>
        </li>
      </ul>
    </div>
    <div class="content-row">
      <div class="col-12" v-if="showlistShop">
        <div class="shop-list-show-border">
          <template>
            <el-table
              :data="good_list"
              style="width: 100%"
              ref="multipleTable"
              v-loading="loading"
            >
              <el-table-column
                prop="spu_name"
                align="center"
                border
                label="产品信息"
                min-width="180px"
              >
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      text-align: left;
                    "
                  >
                    <div style="display: flex">
                      <div
                        style="
                          width: 45%;
                          text-align: right;
                          margin-right: 5px;
                          font-size: 13px;
                        "
                      >
                        {{ scope.row.good_name }}
                      </div>
                      <div style="font-size: 17px; margin-top: -2px">|</div>
                      <div
                        style="width: 45%; margin-left: 5px; font-size: 13px"
                      >
                        {{ scope.row.brand_id }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="spu_name"
                border
                align="center"
                label="规格型号"
                min-width="180px"
              >
                <template slot-scope="scope">
                  <!-- <span v-html="scope.row.good_spec"></span> -->
                  <div
                    style="
                      display: inline-block;
                      cursor: pointer;
                      text-align: left !important;
                      white-space: pre;
                      width: 100%;
                      font-family: Courier New;
                      font-size: 13px;
                    "
                    @click="buyGood(scope.row.id)"
                    :title="scope.row.good_spec"
                  >{{ scope.row.good_spec }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="spu_name"
                align="center"
                border
                label="单价"
                width="80"
              >
                <template slot-scope="scope">
                  <div style="display: inline-block">
                    {{ scope.row.sale_price }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="spu_name"
                align="center"
                border
                label="仓库"
                min-width="120px"
              >
                <template slot-scope="scope">
                  <div
                    style="display: inline-block"
                    v-if="scope.row.ware != false"
                  >
                    <el-select
                      v-model="scope.row.stork_value"
                      value-key="ware_id"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in scope.row.ware"
                        :key="item.ware_id"
                        :label="item.wareInfo.name"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="display: inline-block" v-else>没有仓库</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="spu_name"
                align="center"
                border
                label="库存数量"
                width="80"
              >
                <template slot-scope="scope">
                  <div style="display: inline-block">
                    {{
                      scope.row.stork_value == null
                        ? scope.row.sqty
                        : scope.row.stork_value.qty
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="spu_name"
                align="center"
                label="加入购物车数量"
                min-width="130"
              >
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.cart_count"
                    :disabled="scope.row.ware == false"
                    :min="0"
                    :max="
                      scope.row.stork_value == null
                        ? scope.row.sqty
                        : scope.row.stork_value.qty
                    "
                    :step="
                      scope.row.batch_num == null || scope.row.batch_num == 0
                        ? 1
                        : scope.row.batch_num
                    "
                    label="描述文字"
                    size="mini"
                  ></el-input-number>
                  <!-- @change="handleChange(scope.$index,good_list[scope.$index])" -->
                </template>
                <!-- :max="scope.row.stork_value==null?parseInt(scope.row.sqty):parseInt(scope.row.stork_value.qty)" -->
                <!-- <template slot="header">
                  <el-button type="warning" round @click="join_cart()">加入购物车</el-button>
                </template>-->
              </el-table-column>
              <el-table-column
                prop="spu_name"
                align="center"
                border
                label="加购"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-shopping-cart-full"
                    circle
                    @click="send_cart(scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div>
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[30, 60, 90, 120]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 goods-box" v-if="showListShop">
        <div
          v-for="(item, index) in good_list"
          :key="item.good_itemid"
          class="good_div1"
        >
          <!-- <div class="content-row first-row" v-if="item.made == '1'">
            <span type="primary" class="customized-span" size="mini">可定制</span>
          </div>-->
          <div class="content-row second-row" style="height: 178px">
            <div
              class="demo-image__preview"
              @click="buyGood(item.id)"
              style="height: 100%"
            >
              <el-image
                v-if="item.pic != '' && item.pic != null"
                class
                :src="item.pic"
                style="height: 100%; width: 100%"
              ></el-image>
              <el-image
                v-else
                src="static/image/error.png"
                style="height: 100%; width: 100%"
              ></el-image>
            </div>
          </div>
          <div class="content-left-row price-div">
            <span class="span-price" style="float: left"
              >￥{{ item.sale_price }}</span
            >
            <span style="float: right; color: #000"
              >{{ item.sqty }}&nbsp;&nbsp;{{ item.good_unit_itemid }}</span
            >
          </div>
          <div class="content-left-row spec-div">
            <span
              :title="item.good_spec"
              style="white-space: pre-wrap; overflow: hidden; color: #000"
              >{{ item.good_spec }}</span
            >
          </div>
          <div class="content-left-row goodName-div" style="color: #000000">
            <span :title="item.good_name" style="float: left"
              >{{ item.good_name }}|{{ item.brand_id }}</span
            >
          </div>
          <div class="content-center-row goods-btn">
            <el-button
              style="padding: 3% 5%; min-width: 60px"
              :type="item.is_collect == 1 ? 'primary' : 'button'"
              size="mini"
              plain
              @click="collectionGood(item.is_collect, item.good_itemid)"
            >
              <i class="fa fa-heart" aria-hidden="true"></i>
              {{ item.is_collect == 1 ? "已收藏" : "收藏" }}
            </el-button>
            <el-button
              type="danger"
              @click="buyGood(item.id)"
              size="mini"
              plain
              style="padding: 3% 5%; min-width: 100px"
            >
              <i
                class="fa fa-shopping-cart"
                aria-hidden="true"
                style="margin-rignt: 0px"
              ></i>
              <span>加入购物车</span>
            </el-button>
          </div>
        </div>
        <!-- <div>
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[25, 50, 75, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
        </div>-->
      </div>
    </div>
    <div class="content-row" v-if="showListShop">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[30, 60, 90, 120]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--
      v-for="(item,index) in recommend_list" :key="index"
      :src="item.spu_img_url"
      @click="buyGood(item.good_erpid,item.cate_erpid)"
      {{item.good_name}}
      {{item.price}}
    -->

    <div
      class="col-1 hover-nav-list hover-nav-list1"
      style="bottom: 1%; height: auto"
    >
      <div class="left-boxshadow left-boxshadow-list">
        <span class="span-title">产品推荐</span>
        <ul class="recommend-menu">
          <li v-for="(item, index) in good_recommon" :key="index">
            <div class="content-row pointer content-left-list">
              <div class="content-left-list-item">
                <div
                  class="demo-image__preview"
                  @click="buyGood(item.good_itemid)"
                >
                  <el-image class="recommend-img" :src="item.pic"></el-image>
                </div>
              </div>
              <div class="content-left-list-item content-left-list-item1">
                <div class="content-row recommon-good">
                  <!-- style="text-overflow:ellipsis;white-space:nowrap;overflow:hidden;" -->
                  <div
                    class="span-name outer"
                    :title="item.good_spec"
                    style="width: 90%; white-space: pre-wrap"
                  >{{ item.good_spec }}</div>
                  <div
                    class="span-name outer"
                    :title="item.good_name"
                    style="width: 90%; white-space: pre-wrap"
                  >{{ item.good_name }}</div>
                </div>
                <div class="content-row">
                  <span class="span-money">￥{{ item.sale_price }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="hover-nav-list hover-nav-list2">
      <el-popover
        placement="left-start"
        style="color: red"
        width="200"
        trigger="hover"
      >
        <div class="left-boxshadow left-boxshadow-list">
          <span class="span-title">产品推荐</span>
          <ul class="recommend-menu">
            <li v-for="(item, index) in good_recommon" :key="index">
              <div class="content-row pointer content-left-list">
                <div class="content-left-list-item">
                  <div
                    class="demo-image__preview"
                    @click="buyGood(item.good_itemid)"
                  >
                    <el-image class="recommend-img" :src="item.pic"></el-image>
                  </div>
                </div>
                <div class="content-left-list-item content-left-list-item1">
                  <div class="content-row recommon-good">
                    <div
                      class="span-name outer"
                      :title="item.good_spec"
                      style="width: 90%; white-space: pre-wrap"
                    >
                      {{ item.good_spec }}
                    </div>
                    <div
                      class="span-name outer"
                      :title="item.good_name"
                      style="width: 90%; white-space: pre-wrap"
                    >
                      {{ item.good_name }}
                    </div>
                  </div>
                  <div class="content-row">
                    <span class="span-money">￥{{ item.sale_price }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <el-button
          slot="reference"
          type="primary"
          class="btn_gg"
          size="small"
          icon="el-icon-s-promotion"
          circle
        ></el-button>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { debuglog } from "util";
import Unit from "@/assets/js/Unit";
// var id = this.$route.query.id;
export default {
  name: "Good",
  components: {},
  data() {
    return {
      data: [],
      attr_list_less: [], //属性列表
      attr_list_most: [], //
      good_list: [], //商品列表
      recommend_list: [], //推荐商品
      field: [],
      rowStyle: {
        display: "none",
      },

      addtype: {
        show: false,
      },
      min_price: "",
      max_price: "",
      currentPage: 1,
      pagesize: 30,
      total: 0,
      check_data: [], //选中的数据

      direction: "ttb",
      second_cate_id: "",
      cate_id: "",
      cate_id1: "",
      attr: [],

      shou_attr_num: 3,

      //sort parms
      // name: "",
      // price: "",
      screen: "",

      srcList: ["/index/static/image/good.jpg"],
      showlistShop: true,
      showListShop: false,
      num1: 1,
      value: true,
      tag_list: [],
      cate_list: [],
      good_recommon: [],
      // url_id:'',
      loading: false,
      keyword: "",
    };
  },
  mounted() {
    // this.url_id = this.$route.query.level_id
    this.view();
    let that = this;
    Unit.$on("searchGood", function (keyword) {
      that.currentPage = 1;
      that.getGoodList(keyword);
    });
  },

  methods: {
    view() {
      let level_id = 0;
      if (this.$route.query.level_id != null) {
        level_id = this.$route.query.level_id;
      }

      this.$axios({
        method: "post",
        url: "/index/Catalogue/cate_tree",
        params: {
          pid: level_id,
        },
      })
        .then((res) => {
          if (res.data.parent[0] == null) {
          } else {
            this.tag_list = res.data.parent;
          }
          this.cate_list = res.data.data[0].child;
          if (this.tag_list.length != 0) {
            this.get_attr(
              this.tag_list[this.tag_list.length - 1].good_cate_itemid
            );
          } else {
            this.attr_list_less = [];
            this.attr_list_most = [];
          }
          this.getGoodList();
        })
        .catch((err) => {});
      //请求商品推荐
      this.$axios({
        method: "post",
        url: "/index/good/good_recommend",
        params: {
          cate_id: level_id,
          pagesize: 7,
        },
      })
        .then((res) => {
          this.good_recommon = res.data.data.data;
        })
        .catch((err) => {});
    },

    demo(i) {
      alert(i);
    },
    get_attr(id) {
      // var id = [];
      // for (let i = 0; i < this.cate_list.length; i++) {
      //   id.push(this.cate_list[i].good_cate_itemid);
      // }
      this.$axios({
        method: "post",
        url: "/index/Catalogue/attr",
        params: {
          cate_id: id,
        },
      })
        .then((res) => {
          this.attr_list_less = res.data.data.slice(0, 3);
          this.attr_list_most = res.data.data;
        })
        .catch((err) => {});
    },
    // 删除顶部标签
    handleClose(e, i) {
      this.tag_list.splice(i, 1);
      var level_id = 0;
      if (i != 0) {
        level_id = this.tag_list[i - 1].good_cate_itemid;
      }
      this.$router.replace({
        path: "/Level2HomePage/index",
        query: { level_id: level_id },
      });
      this.view();
    },

    //选择数据
    handleSelectionChange(item) {
      this.check_data = item;
    },
    // 确认加入购物车
    send_cart(e) {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      if (e.stork_value == null) {
        this.$message1("请选择仓库!");
        return;
      }
      if (e.cart_count == 0) {
        this.$message1("请选择数量!");
        return;
      }
      if (e.cart_count > e.sqty) {
        this.$message1("库存不足!");
        return;
      }
      if(e.mini_qty > e.sqty){
        this.$message1("最小起订量：" + e.sqty);
        return;
      }
      this.$axios({
        method: "post",
        url: "/index/cart/add_cart",
        params: {
          good_itemid: e.good_itemid,
          qty: e.cart_count,
          ware_id: e.stork_value.ware_id,
        },
      })
        .then((res) => {
          this.$message1(res.data.msg);

          this.$axios({
            method: "post",
            url: "/index/cart/get_qty",
          })
            .then((res) => {
              this.$store.dispatch("setQty", res.data.data);
              sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
            })
            .catch((err) => {});

          // this.getGoodList();
          // this.attr_list_less = res.data.data.slice(0, 3);
          // this.attr_list_most = res.data.data;
        })
        .catch((err) => {});
    },
    join_cart() {
      // var sure_cart = [];
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      var good_itemid = [];
      var qty = [];
      var ware_id = [];
      if (this.check_data.length == 0) {
        this.$message1("请选择商品");
        return;
      }
      var flag = 0;
      for (let i = 0; i < this.check_data.length; i++) {
        good_itemid.push(this.check_data[i].id);
        if (this.check_data[i].cart_count == 0) {
          flag = 1;
        }
        qty.push(this.check_data[i].cart_count);
        if (this.check_data[i].ware != false) {
          for (let j = 0; j < this.check_data[i].ware.length; j++) {
            ware_id.push(this.check_data[i].ware[j].ware_id);
          }
        }
      }
      if (flag == 1) {
        this.$message1("商品购物车不能为0");
        return;
      }
      this.$axios({
        method: "post",
        url: "/index/cart/add_cart",
        params: {
          good_itemid: good_itemid.join(","),
          qty: qty.join(","),
          ware_id: ware_id.join(","),
        },
      })
        .then((res) => {
          this.$message1("保存成功!");

          this.$axios({
            method: "post",
            url: "/index/cart/get_qty",
          })
            .then((res) => {
              this.$store.dispatch("setQty", res.data.data);
              sessionStorage.setItem("qty", this.$store.getters.getcurrentQty);
            })
            .catch((err) => {});

          // this.getGoodList();
          // this.attr_list_less = res.data.data.slice(0, 3);
          // this.attr_list_most = res.data.data;
        })
        .catch((err) => {});
    },
    showMostListData() {
      $(".attr-table-less").addClass("hide");
      $(".attr-table-most").removeClass("hide");
    },
    showLessListData() {
      $(".attr-table-less").removeClass("hide");
      $(".attr-table-most").addClass("hide");
    },
    showChildMenu(id, e) {
      //  this.get_attr(id)
      if (e.child != null) {
        this.$router.replace({
          path: "/Level2HomePage/index",
          query: { level_id: e.good_cate_itemid },
        });
        this.view();
      } else {
        this.$message1("最后一及分类了哦");
        //请求商品推荐
        this.$axios({
          method: "post",
          url: "/index/good/good_recommend",
          params: {
            cate_id: e.good_cate_itemid,
            pagesize: 7,
          },
        })
          .then((res) => {
            this.good_recommon = res.data.data.data;
          })
          .catch((err) => {});
        //请求属性
        this.get_attr(e.good_cate_itemid);
        //请求商品
        this.$axios({
          method: "post",
          url: "/index/good/search",
          params: {
            page: this.currentPage,
            pagesize: this.pagesize,
            cate_id: e.good_cate_itemid,
            attr_value: this.attr.join(","),
            screen: this.screen,
            fewPrice: this.min_price,
            bigPrice: this.max_price,
          },
        })
          .then((res) => {
            this.good_list = res.data.data.data.data;
            this.total = res.data.data.data.total;
            // this.currentPage = res.data.data.data.current_page;
            // this.pagesize = res.data.data.data.per_page;
            // for (let i = 0; i < this.good_list.length; i++) {
            //   if (this.good_list[i].ware != false) {
            //     this.$set(
            //       this.good_list[i],
            //       "stork_value",
            //       this.good_list[i].ware[0]
            //     );
            //   }
            // }
          })
          .catch((err) => {});
      }
    },
    showAttrMenu(cate_id, index) {
      /* this.cate_id = cate_id;
      if (index != -1) {
        $(".cate-list-detail-li").removeClass("cate-list-detail-li-active");
        $(".menu-active .cate-list-detail-li:eq(" + index + ")").addClass(
          "cate-list-detail-li-active"
        );
      }
      this.$axios({
        method: "post",
        url: "/index/catalogue/attr",
        params: {
          cate_id: cate_id
        }
      })
        .then(res => {
          this.attr_list_less = res.data.data.slice(0, 2);
          this.attr_list_most = res.data.data;
        })
        .catch(err => {});
      this.getGoodList(); */
    },
    getGoodList(keyword) {
      if (this.$route.query.keyword != undefined && keyword == undefined) {
        keyword = this.$route.query.keyword;
      }

      this.keyword = keyword;
      this.loading = true;
      this.$axios({
        method: "post",
        url: "/index/good/search",
        params: {
          page: this.currentPage,
          pagesize: this.pagesize,
          cate_id: this.$route.query.level_id,
          attr_value: this.attr.join(","),
          screen: this.screen,
          fewPrice: this.min_price,
          bigPrice: this.max_price,
          keyword: this.keyword,
          sort: this.name == "" ? this.price : this.name,
          // minprice:this.min_price,
          // maxprice:this.max_price
        },
      })
        .then((res) => {
          this.loading = false;
          this.good_list = res.data.data.data.data;
          this.$axios({
            method: "post",
            url: "/index/good/get_total",
            params: {
              page: this.currentPage,
              pagesize: this.pagesize,
              cate_id: this.$route.query.level_id,
              attr_value: this.attr.join(","),
              screen: this.screen,
              fewPrice: this.min_price,
              bigPrice: this.max_price,
              keyword: keyword,
              sort: this.name == "" ? this.price : this.name,
            },
          })
            .then((result) => {
              this.total = parseInt(result.data.total);
            })
            .catch((err) => {});
        })
        .catch((err) => {});
    },
    showDetailList(e, cate_id) {
      var is_checked = e;
      if (is_checked) {
        this.attr.push(cate_id);
      } else {
        var new_attr = this.attr;
        new_attr.forEach((current, index) => {
          if (cate_id == current) {
            this.attr.splice(index, 1);
          }
        });
      }
      this.getGoodList();
    },
    sortGoodList(params) {
      if (params == "name") {
        if (this.screen == 2) {
          this.screen = 1;
        } else {
          this.screen = 2;
        }
      }
      if (params == "price") {
        if (this.screen == 3) {
          this.screen = 4;
        } else {
          this.screen = 3;
        }
      }
      if (params == "all") {
        this.screen = 0;
      }
      this.getGoodList();
    },
    collectionGood(collect, good_erpid) {
      if (collect == 1) {
        this.$axios({
          method: "post",
          url: "/index/collection/del",
          params: {
            good_erpid: good_erpid,
          },
        })
          .then((res) => {
            if (res.data.status == "ok") {
              this.$message1("取消收藏成功!");
            }
          })
          .catch((err) => {
            // this.$message(res.data.msg);
          });
      } else {
        this.$axios({
          method: "post",
          url: "/index/Collection/create",
          params: {
            id: good_erpid,
          },
        })
          .then((res) => {
            if (res.data.status == "ok") {
              this.$message1(res.data.msg);
            }
          })
          .catch((err) => {
            // this.$message(res.data.msg);
          });
      }
      this.getGoodList();
    },
    buyGood(good_id) {
      if (good_id != "") {
        this.$router.push({
          path: "/GoodDetail/index",
          query: { id: good_id },
        });
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return `background-color:#f8efe7;border-bottom:1px solid lightgray`;
      } else {
        return "";
      }
    },
    /* 大图切换列表 */
    show_listShop(num) {
      if (num == 1) {
        this.showlistShop = !this.showlistShop;
        this.showListShop = !this.showListShop;
      } else {
        this.showlistShop = !this.showlistShop;
        this.showListShop = !this.showListShop;
      }
    },
    /* 加入购物车 */
    handleChange(index, row) {
      if (row.stork_value == null) {
        if (row.cart_count > parseInt(row.sqty)) {
          row.cart_count = row.sqty;
          this.$message1("库存不足!");
        }
      } else {
        if (row.cart_count > parseInt(row.stork_value.qty)) {
          setTimeout(() => {
            row.cart_count = parseInt(row.stork_value.qty);
          }, 100);
          this.$message1("库存不足!");
        }
      }
    },
    /* 分页 */
    handleSizeChange(val) {
      this.pagesize = val;
      this.getGoodList(this.keyword);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getGoodList(this.keyword);
    },
  },
};
</script>
<style lang="less" scoped>
.cu_span {
  width: 20%;
  height: 100%;
  border: 3px solid #f4770f;
  color: #f4770f;
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  padding: 5px 15px 5px 15px;
  cursor: pointer;
}
.cate-menu {
  width: 100%;
  background-color: #d49d45;
  float: left;
  height: 40px;
  line-height: 40px;
  padding-left: 0;
  // margin-bottom: 2.5%;
}
.menu-active {
  display: inline-block;
  color: yellow !important;
  //   border-bottom: 1px solid yellowgreen;
}

.cate-menu li {
  float: left;
  width: auto;
  list-style-type: none;
  margin: 0 2% 0 0;
  height: 100%;
  padding-left: 2%;
  cursor: pointer;
}
.active {
  display: block;
}
.cate-list-detail-li-active {
  color: #2d8de4;
}
.cate-list-detail {
  float: left;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-left: 0;
  position: absolute;
  cursor: pointer;
  left: 0;
}
.cate-list-detail li {
  list-style-type: none;
  width: auto;
  height: 100%;
  padding-left: 0;
  cursor: pointer;
}
.attr-menu {
  float: left;
  width: 15%;
  height: 100%;
  line-height: 40px;
  padding-left: 0;
}
.attr-menu li {
  list-style-type: none;
  width: 100%;
  margin: 0 4% 0 0;
  height: 100%;
  padding-left: 20px;
  background-color: #f8efe7;
  cursor: pointer;
  border: 1px solid lightgrey;
  text-align: left;
}
.attr-list-detail {
  float: left;
  width: 90%;
  height: 40px;
  line-height: 40px;
  position: absolute;
  margin-left: 8%;
  margin-top: -3.5%;
}
.attr-list-detail li {
  list-style-type: none;
  width: auto;
  margin: 0 4% 0 1%;
  height: 100%;
  padding-left: 0;
  color: darkgray;
  cursor: pointer;
}
.goods-btn {
  display: flex;
  width: 90%;
  margin-top: 2%;
  justify-content: center;
  position: absolute;
  bottom: 2%;
}
.hide {
  display: none;
}
.has-gutter {
  display: none;
}
.el-table__header-wrapper {
  display: none;
}
.span-attr-value {
  margin: 0 2% 0 1%;
}
.fillter-menu {
  width: 100%;
  float: left;
  font-size: 14px;
  background-color: whitesmoke;
  padding: 0;
}
.fillter-menu span {
  float: left;
}
.fillter-menu li {
  float: left;
  line-height: 40px;
  list-style-type: none;
  margin: 0 2% 0 1%;
}
.el-icon-d-caret {
  cursor: pointer;
}
.input-price {
  width: 45%;
  float: left;
}
.el-input__inner {
  height: 30px;
  width: 70%;
}
.span-price {
  color: red;
}
.good-list-div {
  width: 17%;
  float: left;
  border: 1px solid lightgray;
  margin-left: 0.7%;
  padding: 1%;
  margin-bottom: 1%;
  cursor: pointer;
}
.col-2 {
  text-align: left;
  box-shadow: 0px 0px 10px lightgrey;
}
.col-2::after {
  display: block; //必须写
  content: ""; //必须写
  z-index: -1;
  width: 100%;
  height: 100%;
  background: lightgray;
  position: absolute;
  bottom: 0;
  left: 4px;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.3);
}
.col-1 {
  width: 10%;
  text-align: left;
  box-shadow: 1px 1px 8px lightgrey;
}
.col-1::after {
  display: block; //必须写
  content: ""; //必须写
  z-index: -1;
  width: 100%;
  height: 100%;
  // background: lightgray;
  position: absolute;
  bottom: 0;
  left: 4px;
}
.content-left-list {
  display: flex;
}
.content-left-list-item {
  flex: 1;
  padding: 2%;
}
.content-left-list-item1 {
  flex: 2;
  padding-left: 1%;
}
.content-left-list-item1 .content-row {
  text-align: left;
}
.col-6 {
  margin: 5%;
}
.recommend-img {
  width: 60px;
  height: 60px;
  float: left;
}
.recommend-menu {
  float: left;
  padding: 0;
  width: 100%;
  margin: 0;
}
.recommend-menu span {
  float: left;
}
.recommend-menu li {
  float: left;
  list-style-type: none;
  width: 100%;
  border-bottom: 1px solid lightgray;
  font-size: 14px;
}
.outer {
  overflow: hidden;
  text-overflow: ellipsis;
  /*设置成弹性盒子 */
  display: -webkit-box;
  /*显示的个数 */
  -webkit-line-clamp: 2;
  /* 属性规定框的子元素应该被水平或垂直排列。 */
  -webkit-box-orient: vertical;
}
.third-row,
.four-row,
.five-row {
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
}
.third-row,
.four-row,
.five-row span {
  float: left;
  cursor: pointer;
}
.six-row {
  color: darkgray;
}
.seven-row {
  text-align: center;
  display: flex;
}
.cate-menu-li {
  float: left;
  list-style-type: none;
  margin: 0 2% 0 0;
  color: #fff;
  height: 100%;
  padding-left: 2%;
  cursor: pointer;
}
.button-icon {
  margin-right: 5%;
  margin-left: -20%;
}
.fa-shopping-cart {
  margin-right: 10%;
  margin-left: -5%;
}
.span-title {
  color: #c39a58;
  margin: 5%;
  font-size: 15px;
  display: inline-block;
  width: 90%;
}

.span-table-most {
  text-align: center;
  display: block;
  cursor: pointer;
}
.span-name {
  font-size: 14px;
  color: #7c7c7c;
  word-break: break-all;
}
.span-money {
  color: #c91815;
  font-weight: 600;
}
.el-table_1_column_2 .cell {
  display: flex;
  flex-wrap: wrap;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}
.attr-table-less {
  margin-top: 1%;
}
.te-li-right {
  float: right !important;
}
.te-li-right-span {
  display: inline-block;
  padding: 0 10px;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
.active {
  color: #c39a58;
}
.errorClass {
  color: #555;
}
.good_pic {
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.shop-list-show-border {
  border: 1px solid #eee;
}
.hover-nav-list {
  position: fixed;
  /*top: 40%;*/
  bottom: 1%;
  left: 0.5%;
}

.left-boxshadow-list {
  background-color: #fff;
  width: 100%;
}
.list-nav-two {
  font-size: 14px;
  margin-top: 4%;
}
.recommon-good {
  overflow: hidden;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/Level2HomePage/index.vue